module.exports = __webpack_public_path__ + "img/register.ab459fbd.png";